import { BcmSettings, BcmSettingsSectionName } from '@shared/models/bcm-settings';
import { ElectricMeterProductKey, ElectricMeterProductType } from '@shared/models/electric-meter-product-type';
import { Product } from '@shared/models/product';
import { findProductById } from '@shared/constants/electric-meter-product-category';

export const NO_PRODUCT_SETTINGS_ID = 9999999;

export function resolveDefaultProductId(
    settings: BcmSettings | undefined,
    productType: ElectricMeterProductType | null | undefined,
): number | null {
    if (!productType || productType.key === ElectricMeterProductKey.NO_CHARGE) {
        return null;
    }
    const productId = settings?.[BcmSettingsSectionName.ElectricMeter]?.[productType.settingsKey];
    if (productId == null || productId === NO_PRODUCT_SETTINGS_ID) {
        return null;
    }
    return productId;
}

export function findDefaultProduct(
    settings: BcmSettings | undefined,
    productType: ElectricMeterProductType | null | undefined,
    allProducts: Product[],
): Product | null {
    const productId = resolveDefaultProductId(settings, productType);
    if (productId == null) {
        return null;
    }
    return findProductById(allProducts, productId);
}
